import { cn } from "@/lib/utils";
import { ErrorBoundary } from "@sentry/react";
import { type HTMLAttributes, type ReactNode } from "react";
import { Helmet } from "react-helmet-async";

export function Page({
  title,
  children,
  className,
  ...props
}: {
  readonly title?: string;
  readonly children: ReactNode;
} & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "min-h-screen bg-gray-100 font-semibold text-gray-800",
        className,
      )}
      {...props}
    >
      <Helmet>
        <title>{title !== undefined ? `${title} | everbay` : "everbay"}</title>
      </Helmet>
      <ErrorBoundary
        fallback={({ error }) => (
          <div className="flex grow flex-col items-center justify-center gap-2">
            <h1 className="text-2xl font-bold">
              Beim Anzeigen dieser Seite ist ein Fehler aufgetreten
            </h1>
            <p className="text-sm">
              Versuchen Sie, die Seite zu aktualisieren.
              <br />
              Wenn das Problem weiterhin besteht, wenden Sie sich bitte mit der
              folgenden Fehlermeldung an den Support:
            </p>
            <pre className="overflow-x-auto rounded-md bg-gray-300 p-2 text-sm">
              {error.message}
            </pre>
          </div>
        )}
      >
        {children}
      </ErrorBoundary>
    </div>
  );
}
